export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";